<template>
  <div class="tfa-line">
    <div class="tfa-l">
      <b>{{ t('me.tfAuto') }}</b>
      <span>{{ t('me.tfAutoDesc') }}</span>
    </div>
    <button
      type="button"
      class="tfa-sw"
      :class="{ on: modelValue }"
      :disabled="disabled"
      :aria-label="t('me.tfAutoAria')"
      @click="emit('update:modelValue', !modelValue)"
    >
      <i />
    </button>
  </div>
</template>

<script setup lang="ts">
defineProps<{
  modelValue: boolean
  disabled?: boolean
}>()

const emit = defineEmits<{
  'update:modelValue': [value: boolean]
}>()

const { t } = useI18n()
</script>

<style scoped lang="scss">
.tfa-line {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 13px;
  background: var(--surface);
  border: 1px solid var(--hairline);
  border-radius: var(--r-md);
}

.tfa-l {
  flex: 1;

  b {
    font-size: 13px;
    display: block;
  }

  span {
    font-size: 11px;
    color: var(--muted);
    display: block;
    margin-top: 2px;
    line-height: 1.5;
  }
}

.tfa-sw {
  width: 44px;
  height: 26px;
  flex: 0 0 44px;
  border-radius: 999px;
  background: var(--surface2);
  border: 1px solid var(--hairline);
  position: relative;
  transition: background 0.2s;
  padding: 0;

  i {
    position: absolute;
    top: 2px;
    left: 2px;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    background: #fff;
    transition: left 0.2s;
    font-style: normal;
  }

  &.on {
    background: var(--primary);

    i {
      left: 20px;
    }
  }

  &:disabled {
    opacity: 0.55;
  }
}
</style>
